import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rentals-products-accessories',
  templateUrl: './rentals-products-accessories.component.html',
  styleUrls: ['./rentals-products-accessories.component.scss'],
})
export class RentalsProductsAccessoriesComponent implements OnInit {
  public selectedTab = 0;

  constructor() {}

  ngOnInit() {}
}
